import SelectRegion from './SelectRegion';
export default SelectRegion;



// WEBPACK FOOTER //
// ./src/pages/MembershipsPage/components/SelectRegion/index.ts